import { render, staticRenderFns } from "./cModalViewDosis.vue?vue&type=template&id=b921372c&lang=es"
import script from "./cModalViewDosis.vue?vue&type=script&lang=js"
export * from "./cModalViewDosis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports